import { render, staticRenderFns } from "./UiShareContestEntryModal.vue?vue&type=template&id=11c1028a&"
import script from "./UiShareContestEntryModal.vue?vue&type=script&lang=js&"
export * from "./UiShareContestEntryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports